<template>
    <div class="ep-box box-sizing">
        <el-alert title="密码修改成功后将退出，您需要重新登录！" type="warning" :closable="false" center show-icon></el-alert>
        <div class="ep-list">
            <div class="ep-item">
                <span class="lab">新密码：</span>
                <el-input class="inp1" placeholder="请输入新密码" v-model="newPass1" show-password></el-input>
            </div>
            <div class="ep-item">
                <span class="lab">确认密码：</span>
                <el-input class="inp1" placeholder="请再次输入新密码" v-model="newPass2" show-password></el-input>
            </div>
            <div class="ep-item">
                <span class="lab">验证码：</span>
                <el-input class="inp2" placeholder="186****5256" v-model="vcode"></el-input>
                <el-button class="btn1" type="primary">获取验证码</el-button>
            </div>
            <div class="ep-item">
                <span class="lab"></span>
                <el-button class="btn2" type="primary">保存</el-button>
                <el-button class="btn2">清空</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EditPass",
        data() {
            return {
                vcode: "",
                newPass1: "",
                newPass2: "",
            }
        },
        mounted() {
        },
        methods: {

        }
    }
</script>

<style scoped>
    .ep-box{
        width: 100%;
        height: auto;
        padding: 20px;
    }
    .ep-box .ep-list{
        width: 100%;
        height: auto;
        padding-top: 40px;
    }
    .ep-box .ep-list .ep-item{
        width: 100%;
        height: 60px;
        line-height: 60px;
    }
    .ep-box .ep-list .ep-item .lab{
        display: inline-block;
        width: 70px;
        height: 60px;
        color: #666666;
        font-size: 14px;
        text-align: right;
        margin-left: 340px;
        margin-right: 10px;
        vertical-align: top;
    }
    .ep-box .ep-list .ep-item .inp1{
        width: 330px;
    }
    .ep-box .ep-list .ep-item .inp2{
        width: 180px;
    }
    .ep-box .ep-list .ep-item .btn1{
        width: 140px;
        margin-left: 10px;
    }
    .ep-box .ep-list .ep-item .btn2{
        width: 160px;
    }
</style>
